import type { ReactNode, SVGProps } from "react";

export function ProfileIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="12"
			viewBox="0 0 9 12"
			width="9"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.7915 2.95833C1.7915 3.57717 2.03734 4.17066 2.47492 4.60825C2.91251 5.04583 3.506 5.29167 4.12484 5.29167C4.74368 5.29167 5.33717 5.04583 5.77475 4.60825C6.21234 4.17066 6.45817 3.57717 6.45817 2.95833C6.45817 2.33949 6.21234 1.746 5.77475 1.30842C5.33717 0.870833 4.74368 0.625 4.12484 0.625C3.506 0.625 2.91251 0.870833 2.47492 1.30842C2.03734 1.746 1.7915 2.33949 1.7915 2.95833Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 11.125V9.95833C0.625 9.33949 0.870833 8.746 1.30842 8.30842C1.746 7.87083 2.33949 7.625 2.95833 7.625H5.29167C5.9105 7.625 6.504 7.87083 6.94158 8.30842C7.37917 8.746 7.625 9.33949 7.625 9.95833V11.125"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
